import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { Utils } from 'src/app/core/resources/utils';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { CargoRatingService } from './cargo-rating.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DateManager } from 'src/app/core/managers/date.manager';
import { DateEnum } from 'src/app/core/enums/date.enum';
import { CargoService } from 'src/app/core/services/cargo.service';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/authentication.service';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { ConsignmentCargo } from 'src/app/core/interfaces/consignmentCargo';
import { CargoDetailService } from '../cargo-detail/cargo-detail.service';

@Component({
  selector: 'app-cargo-rating',
  templateUrl: './cargo-rating.component.html',
  styleUrls: ['./cargo-rating.component.scss']
})
export class CargoRatingComponent implements OnInit {
  public cargo: Cargo;
  public state: string = "";
  public currentRate = 0;
  public commentRateCargo = "";
  public redirect: boolean;

  constructor(
    private cargoRatingService: CargoRatingService,
    private cargoService: CargoService,
    private cargoDetailService: CargoDetailService,
    private authService: AuthService,
    private router: Router,
    private _snackBarService: SnackBarService,
    @Inject(MAT_DIALOG_DATA) public dialogParams: { cargo: Cargo, redirect: boolean, enableClose?: boolean },
    public dialogRef: MatDialogRef<CargoRatingComponent>,
    public utils: Utils,
    private spinner: NgxSpinnerService,
    private cargoManager: CargoManager
  ) { }

  ngOnInit() {
    this.cargo = this.dialogParams.cargo;
    if (this.utils.isDefined(this.dialogParams.redirect)) {
      this.redirect = this.dialogParams.redirect;
    }
  }

  cargoReceived() {
    this.state = "recived";
  }

  cargoNotReceived() {
    this.state = "NoRecived";
  }

  openModalConfirmCargo() {
    this.state = "";
  }
  disabledButtonRate(): boolean {
    return !(this.commentRateCargo.length > 0 && this.currentRate > 0);
  }

  onNoClick(): void {
    if (this.canEndCargoCheck) this.endCargoCheck(false);
    else this.dialogRef.close();
  }

  onSubmit() {
    if (this.canEndCargoCheck) this.endCargoCheck(true);
    else this.rateCargo();
  }

  private async endCargoCheck(rateCargo: boolean) {
    rateCargo ? this.rateCargo() : this.dialogRef.close();
  }

  get canEndCargoCheck(): boolean {
    return !this.cargo.totalConsignmentsInitialApproval && this.cargo.ministry && this.cargo.cargoFeature.uploadDownload.destination.some((destination) => destination.addresses.some((address) => !address.approvalInitialConsignment)) && this.authService && this.authService.getCompany().companyId === environment.rootNit;
  }

  get isSatelliteLockService(): boolean {
    return this.utils.isSatelliteLockService(this.cargo);
  }
  get isTransportService(): boolean {
    return this.utils.isTransportService(this.cargo);
  }
  get isEscortedService(): boolean {
    return this.utils.isEscortedService(this.cargo);
  }

  rateCargo() {
    let params = {
      "score": this.currentRate,
      "reason": this.commentRateCargo,
    };
    this.spinner.show();
    this.cargoRatingService.rateCargo(this.cargo.id, params).subscribe(
      (data) => {
        this.spinner.hide();
        this._snackBarService.openSnackBar("Calificación exitosa");
        this.dialogRef.close({ state: true });
      },
      (error) => {
        this.spinner.hide();
        this._snackBarService.openSnackBar("Ocurrió un error al calificar", undefined, 'error');
      }
    );
  }

  goToList(routeUrl) {
    this.router.navigate([routeUrl]);
  }

}
